import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import mutabakatReducer from "./slices/mutabakatSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    mutabakat: mutabakatReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Allow File objects in actions (for multipart uploads)
      serializableCheck: {
        ignoredActions: ["mutabakat/submit/pending", "mutabakat/submit/fulfilled"],
        ignoredPaths: ["mutabakat.files"],
      },
    }),
});
